enum WorkStatus {
  NOT_STARTED = 10,
  BEING_HANDLED = 20,
  ON_HOLD = 30,
  WORK_READY = 40,
  TECH_READY = 50,
}

export default WorkStatus;

export const WORK_STATUS_TRANSITIONS = {
  [WorkStatus.NOT_STARTED]: [
    WorkStatus.BEING_HANDLED,
    WorkStatus.ON_HOLD,
    WorkStatus.WORK_READY,
  ],
  [WorkStatus.BEING_HANDLED]: [
    WorkStatus.NOT_STARTED,
    WorkStatus.ON_HOLD,
    WorkStatus.WORK_READY,
  ],
  [WorkStatus.ON_HOLD]: [
    WorkStatus.NOT_STARTED,
    WorkStatus.BEING_HANDLED,
    WorkStatus.WORK_READY,
  ],
  [WorkStatus.WORK_READY]: [
    WorkStatus.NOT_STARTED,
    WorkStatus.BEING_HANDLED,
    WorkStatus.ON_HOLD,
    WorkStatus.TECH_READY,
  ],
  [WorkStatus.TECH_READY]: [
    WorkStatus.NOT_STARTED,
    WorkStatus.BEING_HANDLED,
    WorkStatus.ON_HOLD,
    WorkStatus.WORK_READY,
  ],
};

export const READY_WORK_STATUSES = [WorkStatus.WORK_READY, WorkStatus.TECH_READY];